import type { ReactElement } from 'react';
import { NavLink } from 'react-router';
import { GNB_ITEMS, HOME_PATH } from '@/shared/config';
import { cn } from '@/shared/ui';

interface SiteHeaderGnbProps {
  /** 메뉴 목록 글자·간격 — 헤더 배치(알약·쌓은 배치)마다 다르다. */
  readonly listClassName: string;
  /** inverse = 사진 위 흰 글자(HOME 접힌 헤더). */
  readonly tone?: 'default' | 'inverse';
}

/** 넓은 화면(xl 이상)의 주 메뉴 — GNB 는 shared/config/gnb.ts 가 단일 원천이다. */
export const SiteHeaderGnb = ({
  listClassName,
  tone = 'default',
}: SiteHeaderGnbProps): ReactElement => (
  <nav aria-label="주 메뉴" className="hidden xl:block">
    <ul className={cn('flex items-center whitespace-nowrap', listClassName)}>
      {GNB_ITEMS.map((item) => (
        <li key={item.path}>
          <NavLink
            to={item.path}
            // 루트는 모든 경로의 접두사라 end 없이는 항상 활성으로 표시된다.
            end={item.path === HOME_PATH}
            className={({ isActive }) =>
              cn(
                'transition-colors',
                tone === 'inverse'
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground/70 hover:text-foreground',
                isActive &&
                  (tone === 'inverse'
                    ? 'font-semibold text-white'
                    : 'font-semibold text-foreground'),
              )
            }
          >
            {item.label}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);
